export enum AUDIENCE_UPDATE_ERRORS {
  AudienceIsUsedInNotifications = 'AudienceIsUsedInNotifications',
}
